import type { Offer } from 'models';

import { FETCH_REPEAT_PAYMENT_OFFER } from '../../../constants';

type RepeatPaymentOfferAction = {
  type: typeof FETCH_REPEAT_PAYMENT_OFFER;
  payload: Offer;
};

const repeatPaymentOffer = (
  state: Offer | Record<string, never> = {},
  action: RepeatPaymentOfferAction,
) => {
  switch (action.type) {
    case FETCH_REPEAT_PAYMENT_OFFER:
      return action.payload;
    default:
      return state;
  }
};

export { repeatPaymentOffer };
